(ns admin.subscriptions.session
  (:require [re-frame.core :refer [reg-sub subscribe]]))

(reg-sub :session
         (fn [{:keys [session]}] session))

(reg-sub :session/user
         (fn [_ _] (subscribe [:session]))
         (fn [{:keys [user]} _] user))
